import { axios } from 'system/axios'

export const removeAvatar = () => axios.delete<void>('/user/me/avatar')
